import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiResponse } from "src/app/shared/models/api-response.interface";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class NewslettersubcribeApiService {
  apiUrl!: string;
  apiV!: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = environment.apiURL;
    this.apiV = environment.version;
  }
  subscribeNewsletter(email: string): Observable<ApiResponse<any>> {
    return this.httpClient.post<ApiResponse<any>>(this.apiUrl + `/api/${this.apiV}/SubscribeNewsletter`, { email });
  }
}
